import {FC} from 'react';
import {useForm} from 'react-hook-form';
import {TextField} from '../../../components/TextField';
import { VerificationForm } from "../../../components/VerificationForm";
import {useLocation} from "react-router-dom";
import {VerityType} from "../../../types/types";

interface FormValues {
    email: string;
}

interface FindPasswordFormProps {
}

const FindPasswordForm: FC<FindPasswordFormProps> = () => {
    const {pathname} = useLocation();
    const {
        register,
        watch,
        formState: {errors},
    } = useForm<FormValues>();
    const formValues = watch();

    return (
        <div className="flex flex-col space-y-4 mt-5 text-12">
            <TextField
                type="email"
                className="text-12 h-9 border-black"
                label="아이디 (이메일)"
                placeholder="이메일을 입력해주세요."
                helper={errors.email?.message}
                {...register('email', {required: '이메일을 입력해주세요.'})}
            />
            <VerificationForm
                returnUrl={pathname}
                buttonText={"다음"}
                verifyType={VerityType.PASSWORD}
                userEmail={formValues.email}
                className={`text-black`}
                innerTxtColor={`tx_FF0000`}
                buttonColor={`bg-black text-white`}
                innerTxtColor2={`text-black`}
            />
        </div>
    );
};

export default FindPasswordForm;

